module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-area', {
    attrs: {
      "integration": _vm.currentIntegration
    }
  }, [_c('div', {
    staticClass: "bg-blue-pale p-2 mt-3"
  }, [_vm._v("\n            Please note that you need to have active products on GYG in order to connect with Pluralo. Log into your "), _c('a', {
    staticClass: "darkest underlined",
    attrs: {
      "href": "https://supplier.getyourguide.com/",
      "target": "_blank"
    }
  }, [_vm._v("Supply Portal")]), _vm._v(".  Don’t have an account? "), _c('a', {
    staticClass: "darkest underlined",
    attrs: {
      "href": "https://supplier.getyourguide.com/en/register",
      "target": "_blank"
    }
  }, [_vm._v("Sign Up here")]), _vm._v(".\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 pt-4 pb-4"
  }, [_c('div', {}, [_c('div', {
    staticClass: "d-flex stepRow"
  }, [_c('div', {
    staticClass: "stepNumber d-flex border-dark align-items-center justify-content-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "stepText d-flex flex-grow-1"
  }, [_vm._v("\n                    Set your commissions and payment protocol with GetYourGuide.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "stepButton d-flex"
  }, [(_vm.creatingProtocol) ? _c('loader') : (!_vm.isIntegrated) ? _c('button', {
    staticClass: "btn tertiary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.crateProtocol()
      }
    }
  }, [_vm._v("Create Protocol")]) : (_vm.isIntegrated) ? _c('button', {
    staticClass: "btn tertiary w-100",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-check color-3"
  }), _vm._v(" Created")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex stepRow"
  }, [_c('div', {
    staticClass: "stepNumber d-flex border-dark align-items-center justify-content-center"
  }, [_vm._v("2")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "stepButton d-flex"
  }, [_c('button', {
    staticClass: "btn tertiary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickInstructionsGuide
    }
  }, [_vm._v("Instructions Guide")])])]), _vm._v(" "), (_vm.isIntegrated) ? _c('div', {
    staticClass: "d-flex stepRow justify-content-between"
  }, [_c('button', {
    staticClass: "btn action",
    attrs: {
      "type": "button",
      "disabled": _vm.isDeactivating
    },
    on: {
      "click": function($event) {
        return _vm.deactivateIntegration()
      }
    }
  }, [_vm._v("Disable Integration")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openAgentDetails()
      }
    }
  }, [_vm._v("Open GYG Agent Details")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "productListHolder"
  }, [_c('list', {
    staticClass: "mt-4",
    attrs: {
      "header": _vm.productListHeader,
      "body": _vm.productListBody,
      "rows": _vm.products
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-4"
  }, [_c('button', {
    staticClass: "btn wide tertiary flex-grow-1 mr-2",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn wide primary flex-grow-1 ml-2",
    attrs: {
      "type": "button",
      "name": "button",
      "disabled": !_vm.isIntegrated
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Done, I’m connected")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepText d-flex flex-grow-1"
  }, [_c('div', [_vm._v("\n                        Log into your "), _c('a', {
    staticClass: "color-1 underlined bold",
    attrs: {
      "href": "https://supplier.getyourguide.com/",
      "target": "_blank"
    }
  }, [_vm._v("Supply Portal")]), _vm._v(" and using the table bellow connect the products ID."), _c('br'), _c('b', [_vm._v("Follow the GYG instructions guide to finish the connection on their site")]), _vm._v(".\n                    ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-81377a36", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81377a36"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/otas/getYourGuide/howToConnect/howToConnect.vue
// module id = 3192
// module chunks = 0